import React, { Component } from 'react';
import PropTypes from 'prop-types';
import lodashMap from 'lodash/map';
import { Button, Panel } from 'react-bootstrap';
import { Translate, I18n } from 'react-redux-i18n';

import {
  desiredShapeByQuantity,
  desiredShapeBuyAGetB,
  desiredShapeByTotalPriceProduct,
  desiredShapeByTotalPriceDiscount,
  cleanProduct,
  populateFields,
  isIncompleteForm,
} from '../utils';
import {
  PromotionSetup,
  PromotionsProductSearch,
  BuyAGetBProductSearches,
  ByQuantityFields,
  ByTotalPriceProductFields,
  BuyAGetBFields,
  ByTotalPriceDiscountFields,
} from '../components';

import { saveEdittedPromotion } from '../../../../actions/promotions_actions';
import SpinnerButton from '../../../Common/SpinnerButton';
import Spinner from '../../../Widgets/spinner';
import { ROOT_URL, ROOT_API_URL} from '../../../../actions/root_url';

const isAFM = ROOT_API_URL === 'https://afm-scm.truckxi.com/api/' || ROOT_URL === 'https://afm-scm.truckxi.com/api/';

const propTypes = {
  promotion: PropTypes.shape({
    PromotionLine_id: PropTypes.number,
    Method: PropTypes.string,
    FromQty: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    ToQty: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    Off: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    IsPercent: PropTypes.bool,
    PaymentType: PropTypes.string,
    Group: PropTypes.string,
    Qualification: PropTypes.string,
    StartDate: PropTypes.string,
    EndDate: PropTypes.string,
    RelatedQuantity: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    MinPurchase: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    PromoCode: PropTypes.string,
    ViewablePriceLevels: PropTypes.string,
  }),
  customerList: PropTypes.arrayOf(PropTypes.shape({
    value: PropTypes.string,
    label: PropTypes.string,
  })),
  isLoadingPromoDetails: PropTypes.bool,
  searchProduct: PropTypes.bool,
  closeEditPromotion: PropTypes.func,
};

const defaultProps = {
  promotion: {},
  customerList: [],
  isLoadingPromoDetails: false,
  searchProduct: true,
  closeEditPromotion: () => {},
};

class EditPromotionModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoadingSavePromotion: false,

      startDateSelected: null,
      endDateSelected: null,
      customerGroupSelected: '',
      paymentTypeSelected: '',

      suggestValue: '',
      productSearchType: 'ProductNum',
      selectedProduct: {},

      methodSelected: '',
      discountValue: '',
      discountType: 'Dollar',
      quantityFrom: '',
      quantityTo: '',

      ViewablePriceLevels: '',
      applyLv1: true,
      applyLv2: true,
      applyLv3: true,
      applyLv4: true,
      applyLv5: true,

      minPurchasePrice: '',

      productQuantityA: '',
      productQuantityB: '',

      promoCode: '',
      autoApply: false,
      IsOneTime: false,
      IsPublic: true,

      suggestValueA: '',
      productSearchTypeA: 'ProductNum',
      selectedProductA: '',

      suggestValueB: '',
      productSearchTypeB: 'ProductNum',
      selectedProductB: '',

      SalesType: '',
    };
  }

  componentDidMount() {
    if (this.props.customerList) {
      const { customerList } = this.props;
      this.setState({ customerList });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.promotion && nextProps.promotion !== this.props.promotion) {
      const state = populateFields(this.state, nextProps.promotion);
      this.setState(state);
    }
  }

  getCustomerOptions = () => {
    const { customerList } = this.state;
    const customerOptions = [{ value: 'All', label: 'All' }];
    lodashMap(customerList, (customer) => {
      const option = { value: customer.Name, label: customer.Name };
      customerOptions.push(option);
    });
    return customerOptions;
  }

  setStartDate = (e) => {
    if (this.state.endDateSelected && e > this.state.endDateSelected) {
      alert(I18n.t('please_select_an_end_date_that_is_after_the_start_date'));
      return;
    }
    this.setState({ startDateSelected: e });
  }

  setEndDate = (e) => {
    if (this.state.startDateSelected && e < this.state.startDateSelected) {
      alert(I18n.t('please_select_a_start_date_that_is_before_the_end_date'));
      return;
    }
    this.setState({ endDateSelected: e });
  }

  handleSaveEdittedPromotion = () => {
    const handleSuccess = () => {
      this.setState({ isLoadingSavePromotion: false }, () => {
        this.props.closeEditPromotion(true);
      });
    };

    const handleFailure = (error) => {
      this.setState({ isLoadingSavePromotion: false });
      alert(JSON.stringify(error));
    };

    const promotionLineId = this.props.promotion.PromotionLine_id;
    let promotionLine;
    switch (this.props.promotion.Method) {
      case 'ByQuantity':
        promotionLine = desiredShapeByQuantity(this.state);
        break;
      case 'BuyAGetB':
        promotionLine = desiredShapeBuyAGetB(this.state);
        break;
      case 'ByTotalPriceProduct':
        promotionLine = desiredShapeByTotalPriceProduct(this.state);
        break;
      case 'ByTotalPriceDiscount':
        promotionLine = desiredShapeByTotalPriceDiscount(this.state);
        break;
      default:
        break;
    }
    this.setState({ isLoadingSavePromotion: true }, () => {
      saveEdittedPromotion(promotionLineId, promotionLine, handleSuccess, handleFailure);
    });
  }

  handleSelectionChange = (value, fieldName) => {
    this.setState({ [fieldName]: value });
  }

  handlePriceLevelChange = (fieldName) => {
    if (this.state[[fieldName]] === true) {
      this.setState({ [fieldName]: false });
    } else {
      this.setState({ [fieldName]: true});
    }
  }

  handleOptionChange = (changeEvent, productSearchType) => {
    this.setState({ [productSearchType]: changeEvent.target.value });
  }

  handleDiscountButtonClick = (discountType) => {
    this.setState({ discountType });
  }

  handleProductSuggestChange = (e, newValue, fieldName) => {
    this.setState({ [fieldName]: newValue });
  }

  handleClearButtonClick = (selectedProductName, suggestValueName) => {
    this.setState({ [selectedProductName]: {}, [suggestValueName]: '' });
  }

  handleDuplicateProductAClick = () => {
    const { selectedProductA } = this.state;
    this.setState({ selectedProductB: selectedProductA });
  }

  handleTextInputChange = (event) => {
    this.setState({ [event.target.name]: event.target.value });
  }

  handleCheckBoxChange = (event) => {
    if (event.target.name === 'IsOneTime' && this.state[event.target.name] === false) {
      this.setState({ autoApply: false });
    }
    this.setState({ [event.target.name]: !this.state[event.target.name] });
  }

  selectInventoryInfo = (productNum, selectedInventoryRow, selectedProduct) => {
    const product = cleanProduct(selectedInventoryRow);
    this.setState({
      [selectedProduct]: product,
      suggestValue: '',
    });
  }

  renderByQuantityPromoDetails = () => (
    <div className="promo-section" style={this.props.searchProduct ? {} : { width: '500px' }}>
      <PromotionSetup
        setStartDate={this.setStartDate}
        startDateSelected={this.state.startDateSelected}
        setEndDate={this.setEndDate}
        endDateSelected={this.state.endDateSelected}
        handleSelectionChange={this.handleSelectionChange}
        customerGroupSelected={this.state.customerGroupSelected}
        paymentTypeSelected={this.state.paymentTypeSelected}
        customerOptions={this.getCustomerOptions()}
      />
      <ByQuantityFields
        paymentTypeSelected={this.state.paymentTypeSelected}
        methodSelected={this.state.methodSelected}
        quantityFrom={this.state.quantityFrom}
        quantityTo={this.state.quantityTo}
        discountValue={this.state.discountValue}
        discountType={this.state.discountType}
        applyLv1={this.state.applyLv1}
        applyLv2={this.state.applyLv2}
        applyLv3={this.state.applyLv3}
        applyLv4={this.state.applyLv4}
        applyLv5={this.state.applyLv5}
        handlePriceLevelChange={this.handlePriceLevelChange}
        handleSelectionChange={this.handleSelectionChange}
        handleTextInputChange={this.handleTextInputChange}
        handleDiscountButtonClick={this.handleDiscountButtonClick}
      />
    </div>
  );

  renderBuyAGetBPromoDetails = () => (
    <div className="promo-section">
      <PromotionSetup
        setStartDate={this.setStartDate}
        startDateSelected={this.state.startDateSelected}
        setEndDate={this.setEndDate}
        endDateSelected={this.state.endDateSelected}
        handleSelectionChange={this.handleSelectionChange}
        customerGroupSelected={this.state.customerGroupSelected}
        paymentTypeSelected={this.state.paymentTypeSelected}
        customerOptions={this.getCustomerOptions()}
      />
      <BuyAGetBFields
        methodSelected={this.state.methodSelected}
        productQuantityA={this.state.productQuantityA}
        productQuantityB={this.state.productQuantityB}
        discountValue={this.state.discountValue}
        discountType={this.state.discountType}
        handleSelectionChange={this.handleSelectionChange}
        handleDiscountButtonClick={this.handleDiscountButtonClick}
        handleTextInputChange={this.handleTextInputChange}
      />
    </div>
  );

  renderByTotalPriceProductPromoDetails = () => (
    <div className="promo-section" style={this.props.searchProduct ? {} : { width: '500px' }}>
      <PromotionSetup
        setStartDate={this.setStartDate}
        startDateSelected={this.state.startDateSelected}
        setEndDate={this.setEndDate}
        endDateSelected={this.state.endDateSelected}
        handleSelectionChange={this.handleSelectionChange}
        customerGroupSelected={this.state.customerGroupSelected}
        paymentTypeSelected={this.state.paymentTypeSelected}
        customerOptions={this.getCustomerOptions()}
      />
      <ByTotalPriceProductFields
        editing={true}
        autoApply={this.state.autoApply}
        promoCode={this.state.promoCode}
        minPurchasePrice={this.state.minPurchasePrice}
        productQuantityB={this.state.productQuantityB}
        SalesType={this.state.SalesType}
        handleTextInputChange={this.handleTextInputChange}
        handleCheckBoxChange={this.handleCheckBoxChange}
        handleSelectionChange={this.handleSelectionChange}
      />
    </div>
  );

  renderByTotalPriceDiscountPromoDetails = () => (
    <div className="promo-section" >
      <PromotionSetup
        setStartDate={this.setStartDate}
        startDateSelected={this.state.startDateSelected}
        setEndDate={this.setEndDate}
        endDateSelected={this.state.endDateSelected}
        handleSelectionChange={this.handleSelectionChange}
        customerGroupSelected={this.state.customerGroupSelected}
        paymentTypeSelected={this.state.paymentTypeSelected}
        customerOptions={this.getCustomerOptions()}
      />
      <ByTotalPriceDiscountFields
        minPurchasePrice={this.state.minPurchasePrice}
        discountValue={this.state.discountValue}
        discountType={this.state.discountType}
        SalesType={this.state.SalesType}
        handleDiscountButtonClick={this.handleDiscountButtonClick}
        handleTextInputChange={this.handleTextInputChange}
        handleSelectionChange={this.handleSelectionChange}
      />
    </div>
  );

  renderByQuantity = () => (
    <div className="by-quantity-tab" style={this.props.searchProduct ? {} : { height: '176px' }}>
      {
        (this.props.searchProduct)
        ?
          <div>
            <PromotionsProductSearch
              productSearchType={this.state.productSearchType}
              suggestValue={this.state.suggestValue}
              selectedProduct={this.state.selectedProduct}
              handleOptionChange={this.handleOptionChange}
              handleProductSuggestChange={this.handleProductSuggestChange}
              selectInventoryInfo={this.selectInventoryInfo}
            />
            <hr />
          </div>
        :
          <div />
      }
      { this.renderByQuantityPromoDetails() }
    </div>
  );

  renderByTotalPriceProduct = () => (
    <div className="by-total-price-product-tab" style={this.props.searchProduct ? {} : { height: '176px' }}>
      {
        (this.props.searchProduct)
        &&
        <div>
          <PromotionsProductSearch
            productSearchType={this.state.productSearchType}
            suggestValue={this.state.suggestValue}
            selectedProduct={this.state.selectedProduct}
            handleOptionChange={this.handleOptionChange}
            handleProductSuggestChange={this.handleProductSuggestChange}
            selectInventoryInfo={this.selectInventoryInfo}
          />
          <hr />
        </div>
      }
      { this.renderByTotalPriceProductPromoDetails() }
    </div>
  );

  renderBuyAGetB = () => (
    <div className="buy-a-get-b-tab">
      <BuyAGetBProductSearches
        methodSelected={this.state.methodSelected}
        productSearchTypeA={this.state.productSearchTypeA}
        suggestValueA={this.state.suggestValueA}
        selectedProductA={this.state.selectedProductA}
        productSearchTypeB={this.state.productSearchTypeB}
        suggestValueB={this.state.suggestValueB}
        selectedProductB={this.state.selectedProductB}
        handleOptionChange={this.handleOptionChange}
        handleProductSuggestChange={this.handleProductSuggestChange}
        selectInventoryInfo={this.selectInventoryInfo}
        handleClearButtonClick={this.handleClearButtonClick}
        handleDuplicateProductAClick={this.handleDuplicateProductAClick}
      />
      <hr />
      { this.renderBuyAGetBPromoDetails() }
    </div>
  );

  renderByTotalPriceDiscount = () => (
    <div className="by-total-price-discount-tab">
      <div className="promo-code-section">
        <label htmlFor="promo-code" className="promo-code-label"><Translate value="promo_code" />:</label>
        <input
          id="promo-code-text-input"
          name="promoCode"
          className="text-input-field"
          type="text"
          value={this.state.promoCode}
          onChange={this.handleTextInputChange}
        />
        <div className="auto-apply-wrapper">
          <input
            id="auto-apply-checkbox"
            name="autoApply"
            type="checkbox"
            disabled={this.state.IsOneTime}
            checked={this.state.autoApply}
            onChange={this.handleCheckBoxChange}
          />
          <label htmlFor="auto-apply" className="auto-apply-label"><Translate value="auto_apply" /></label>
        </div>
        <div className="auto-apply-wrapper">
          <input
            id="one-time-checkbox"
            name="IsOneTime"
            type="checkbox"
            checked={this.state.IsOneTime}
            onChange={this.handleCheckBoxChange}
          />
          <label htmlFor="one-time" className="one-time-label"><Translate value="one_time_use" /></label>
        </div>
        {
          isAFM && 
          <div className="auto-apply-wrapper">
            <input
              id="is-public-checkbox"
              name="IsPublic"
              type="checkbox"
              checked={this.state.IsPublic}
              onChange={this.handleCheckBoxChange}
            />
            <label htmlFor="is-public" className="is-public-label"><Translate value="is_public" /></label>
          </div>
        }
      </div>
      <hr />
      { this.renderByTotalPriceDiscountPromoDetails() }
    </div>
  );

  render() {
    const { isLoadingPromoDetails, searchProduct } = this.props;
    const type = this.props.promotion.Method;
    let promoTypeToRender;
    switch (this.props.promotion.Method) {
      case 'ByQuantity':
        promoTypeToRender = this.renderByQuantity();
        break;
      case 'BuyAGetB':
        promoTypeToRender = this.renderBuyAGetB();
        break;
      case 'ByTotalPriceProduct':
        promoTypeToRender = this.renderByTotalPriceProduct();
        break;
      case 'ByTotalPriceDiscount':
        promoTypeToRender = this.renderByTotalPriceDiscount();
        break;
      default:
        break;
    }
    return (
      <Panel id="edit-promotion-modal" style={searchProduct ? {} : { height: '180px' }}>
        {
          (isLoadingPromoDetails)
            ? <Spinner />
            : (
              <div className="promo-details">
                { promoTypeToRender }
                <div className="save-and-cancel-section">
                  <Button
                    bsStyle="danger"
                    onClick={() => this.props.closeEditPromotion()}
                  >
                    <em className="fa fa-close" /><Translate value="cancel" />
                  </Button>
                  <SpinnerButton
                    bsStyle="success"
                    className="save-button"
                    onClick={this.handleSaveEdittedPromotion}
                    disabled={this.state.isLoadingSavePromotion || isIncompleteForm(this.state, type)}
                    loading={this.state.isLoadingSavePromotion}
                    icon="fa-save"
                    translation={<Translate value="save" />}
                  />
                </div>
              </div>
            )
        }
      </Panel>
    );
  }
}

EditPromotionModal.propTypes = propTypes;
EditPromotionModal.defaultProps = defaultProps;

export default EditPromotionModal;



// WEBPACK FOOTER //
// ./master/jsx/components/Sales/PromotionsPage/components/EditPromotionModal.jsx